var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomaticZoomSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.792,14.392h-3.4v3.4h-2.2v-3.4h-3.4v-2.199h3.4v-3.4h2.2v3.4h3.4V14.392z M22.147,2.758v2.325 c-2.267-2.435-5.466-3.89-8.855-3.89c-6.672,0-12.1,5.428-12.1,12.1h2.2c0-5.459,4.441-9.9,9.9-9.9c2.81,0,5.459,1.225,7.318,3.267 h-2.363v2.199h6.1v-6.1H22.147z M29.518,24.912l-4.771-3.936c-1.001,1.488-2.284,2.771-3.771,3.772l3.936,4.771 c0.585,0.709,1.448,1.142,2.368,1.186c0.052,0.003,0.104,0.004,0.155,0.004c0.865,0,1.701-0.345,2.315-0.959 c0.65-0.65,0.998-1.55,0.955-2.469C30.66,26.361,30.228,25.498,29.518,24.912z M23.192,13.292c0,5.459-4.441,9.9-9.9,9.9 c-2.811,0-5.461-1.225-7.319-3.267h2.363v-2.199h-6.1v6.1h2.2v-2.324c2.266,2.435,5.465,3.89,8.855,3.89 c6.672,0,12.1-5.428,12.1-12.1H23.192z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticZoomSelected);
export default __webpack_public_path__ + "static/media/automatic-zoom-selected.cd8e31d16635b6aac7a85cd7c03ea113.svg";
export { ForwardRef as ReactComponent };